import { getJSON, postJSON } from '@folklore/fetch';

const locale = window ? window.LOCALE || 'en' : 'en';
const getLocaleHeaders = () =>
    locale !== null
        ? {
              'Accept-Language': locale,
          }
        : null;

export const loadPage = url =>
    getJSON(url, {
        credentials: 'same-origin',
        headers: {
            ...getLocaleHeaders(),
        },
    });

export const sendNewsletter = (url, data) =>
    postJSON(url, data, {
        credentials: 'same-origin',
        headers: {
            ...getLocaleHeaders(),
        },
    });

export default {
    loadPage,
    sendNewsletter,
};
